module.exports = __webpack_public_path__ + "assets/lessons/en/lesson4/modals/lesson_4_5_c.pdf";